import { message } from "antd";
import { RcFile } from "antd/es/upload";
import { APP_SETTINGS, IMAGE_TYPE_EXTENSIONS, VIDEO_TYPE_EXTENSIONS } from "constant";
import heic2any from "heic2any";
import i18n from "i18n";
import { FileUploadConfig } from "models";
import { getImageSize } from "react-image-size";
import { OtherUtil } from "./other";
import { FormDataUtil } from "./form";
import { FileServices } from "services/file";

export const uploadUtil = {
  validateFile,
  dummyRequest,
  getBase64,
  checkRatio,
  getFileType,
  getBase64ForMultipleUpload,
  convertImageHeic,
  handleImageUpload,
};

function extractBase64FromContent(content: string) {
  const base64Regex = /data:image\/[^;]+;base64[^"]+/g;
  return content.match(base64Regex) || [];
}

async function handleImageUpload(content: string) {
  const base64Images: any = extractBase64FromContent(content);
  const updatedContent = await base64Images.reduce(async (content: string, base64Image: string) => {
    const imageData = base64Image.split(",")[1];
    const byteCharacters = atob(imageData);
    const byteArrays = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays[i] = byteCharacters.charCodeAt(i);
    }

    const blob = new Blob([byteArrays], { type: "image/jpeg" });

    const imageUrl = (await hadleUploadFiles({ files: [blob] })) as any;
    return content.replace(base64Image, imageUrl);
  }, content);
  return updatedContent;
}

async function hadleUploadFiles(data: any) {
  const formData = FormDataUtil.convertJsonToFormData(data, {
    handelObjectInArr: (input) => {
      const temp = FormDataUtil.transformObjectFormData({
        mainKey: input.mainKey,
        data: input.data,
        mainIdx: input.mainIdx,
        customKeyForm: ({ mainKey, key, mainIdx }) => {
          return `${mainKey}[${mainIdx}][${key}]`;
        },
      });
      return temp;
    },
  });
  const dataRes = await FileServices.createFiles(formData);
  if (dataRes) {
    // insertToEditor(dataRes.data[0].url);
    return dataRes.data[0].url;
  }
}

function getBase64ForMultipleUpload(fileList: any[], callback: any) {
  const reader = new FileReader();
  const results: any[] = [];
  let count = 0;

  const onLoadHandler = () => {
    results.push({
      uid: fileList[count].uid,
      url: reader.result,
    });
    count++;

    if (count === fileList.length) {
      // console.log(80, { count, fileList });
      callback(results);
    } else {
      readNext();
    }
  };

  const readNext = () => {
    if (count < fileList.length) {
      const file = fileList[count].originFileObj;

      if (file) {
        reader.readAsDataURL(file);
      } else {
        count++;
        readNext();
      }
    }
  };

  reader.addEventListener("load", onLoadHandler);

  readNext();
}

async function convertImageHeic(file: RcFile) {
  let url = "";
  const blobURL = URL.createObjectURL(file);
  await fetch(blobURL)
    .then((res) => res.blob())
    .then((blob) => heic2any({ blob, toType: "image/jpeg" }))
    .then((conversionResult) => {
      console.log(64, conversionResult);
      url = URL.createObjectURL(conversionResult as Blob);
    })
    .catch((e) => {});
  return url;
}

async function getBase64(file: RcFile, callback: any) {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.addEventListener("load", () => callback(reader.result));
}

function dummyRequest(option: any) {
  setTimeout(() => {
    OtherUtil.loadCallback(option.onSuccess, "ok");
  }, 0);
}

function validateFile(file: File, config?: FileUploadConfig) {
  const fileTypes = config?.format || APP_SETTINGS.UPLOAD_FILE_EXT;
  const maxSize = config?.size || APP_SETTINGS.UPLOAD_MAX_FILE_SIZE;

  const ext = file.name.split(".").pop()?.toLowerCase();

  const isValidType = ext && fileTypes.includes(ext);
  if (!isValidType) {
    message.error(
      i18n.t("UPLOAD_ERROR_FORMAT", {
        FORMAT: config?.formatTitle || `${fileTypes?.map((i) => i.toUpperCase()).join(", ")}`,
      })
    );
  }
  const isValidSize = file.size / 1024 / 1024 < maxSize;
  if (!isValidSize) {
    message.error(i18n.t("UPLOAD_ERROR_SIZE", { SIZE: maxSize }));
  }

  return isValidType && isValidSize;
}

// check width:height of image
// ratio 1:1
async function checkRatio(file: any, config?: FileUploadConfig) {
  if (!config || !config.ratio) return true;
  const ratio = config?.ratio?.split(":");
  try {
    if (ratio?.length) {
      const w = Number(ratio[0]);
      const h = Number(ratio[1]);
      const { width, height } = await getImageSize(file);
      if (w / h === width / height) return true;
    }
  } catch (e) {
    console.log(e);
  }
  return false;
}

function getFileType(path?: string) {
  if (!path) return "Unknown";
  const ext = path.split(".").pop();
  if (ext) {
    if (IMAGE_TYPE_EXTENSIONS.includes(ext)) return "PHOTO";
    if (VIDEO_TYPE_EXTENSIONS.includes(ext)) return "VIDEO";
    return "Unknown";
  }
  return "Unknown";
}

export default uploadUtil;
